import MundialRequestTask from "./MundialRequestTask";

export class TeamsTask  extends MundialRequestTask {

  constructor() {
    super();
  }

  getUrl() {
    const baseUrl = this.getBaseUrl();
    return `${baseUrl}/leagues/${this.leagueId}/teams`;
  }

  getParams() {
    const params = super.getParams();
    return {
      ...params
    };
  }
}


// WEBPACK FOOTER //
// ./src/mundial/requests/tasks/TeamsTask.ts